import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { catchError, defer, of, switchMap } from 'rxjs';
import { environment } from '../../environments/environment';

export function isApplicationApiRequest(url: string): boolean {
  const trimmed = String(url ?? '').trim();
  if (!trimmed || /(^|\/)assets\//i.test(trimmed)) return false;

  if (!/^https?:\/\//i.test(trimmed)) return true;

  try {
    const requestUrl = new URL(trimmed);
    const apiUrl = new URL(environment.URL);
    const apiPath = apiUrl.pathname.replace(/\/$/, '');
    return requestUrl.origin === apiUrl.origin &&
      (!apiPath || requestUrl.pathname.startsWith(`${apiPath}/`) || requestUrl.pathname === apiPath);
  } catch {
    return false;
  }
}

export const authHeadersInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isApplicationApiRequest(req.url) || req.headers.has('Authorization')) {
    return next(req);
  }

  const keycloak = inject(KeycloakService);
  if (!keycloak.isLoggedIn()) return next(req);

  return defer(() => keycloak.updateToken(30)).pipe(
    catchError(() => of(false)),
    switchMap(() => {
      const token = keycloak.getKeycloakInstance().token;
      if (!token) return next(req);

      return next(req.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      }));
    }),
  );
};
